<template lang="pug">

  .lesson-block__content.lesson-test-.-questions-
    Header(
      :title="content.preview.title"
      :currentQuestionIdx="currentQuestionIdx"
      :questionsLength="content.questions.length"
    )

    Swiper(
      ref="systemSwiper"
      :options="swiperOptions"
    )
      SwiperSlide(v-for="(question, idx) in content.questions" :key="idx")
        Question(
          :propQuestion="question"
          :isChecking="isChecking"
          @updateUserAnswerIds="updateUserAnswerIds($event, idx)"
        )

    Navigation(
      :questions="content.questions"
      :currentQuestionIdx="currentQuestionIdx"
      :isLoading="isLoading"
      :isChecking="isChecking"
      @sendAnswer="sendAnswer"
    )

</template>

<script>
import _ from 'lodash';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import Question from './Question';
import Navigation from './Navigation';
import Header from '../Header';

export default {
  components: {
    Header,
    Swiper,
    SwiperSlide,
    Question,
    Navigation
  },
  directives: {
    swiper: directive
  },
  props: ['propContent'],
  data: () => ({
    swiperOptions: {
      loop: false,
      simulateTouch: false,
      autoHeight: true
    },
    isChecking: false,
    currentQuestionIdx: 0,
    content: {
      preview: {},
      questions: []
    },
    navText: '',
    isLoading: false
  }),
  computed: {
    swiper() {
      return this.$refs.systemSwiper.$swiper;
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.content = _.cloneDeep(this.propContent);
      this.content.questions.forEach((question, idx) => {
        if (question.userAnswerIds.length > 0) {
          this.currentQuestionIdx = idx + 1;
        }
      });
      this.swiper.slideTo(this.currentQuestionIdx);
    },
    updateUserAnswerIds(newIds, idx) {
      this.content.questions[idx].userAnswerIds = _.cloneDeep(newIds);
    },
    goToNextQuestion() {
      if (this.currentQuestionIdx + 1 <= this.content.questions.length - 1) {
        this.currentQuestionIdx++;
        this.swiper.slideTo(this.currentQuestionIdx);
      } else {
        this.$emit('finishTest');
      }
    },
    async sendAnswer() {
      const questionId = this.content.questions[this.currentQuestionIdx].id;
      const answerIds = _.cloneDeep(
        this.content.questions[this.currentQuestionIdx].userAnswerIds
      );
      if (answerIds.length === 0) {
        await this.$store.dispatch(
          'ajax/addMessage',
          { message: 'Выберите ответ', type: 'error' },
          { root: true }
        );
        return;
      }

      if (this.isChecking) {
        this.isLoading = true;
        const res = await this.$store.dispatch('coursesLesson/sendTestAnswer', {
          questionId,
          answerIds
        });
        if (res) {
          this.$emit('setPoints', res);
          this.goToNextQuestion();
        }
        this.isLoading = false;
      }
      this.isChecking = !this.isChecking;
    }
  }
};
</script>
